import React, { useState, useEffect, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuOutlined from "@mui/icons-material/MenuOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";

import Aside from "../aside/aside";
import { useLocation } from "react-router";
import "./styles/styles.scss";

import colors from "../../../../../assets/styles/variables/_colors.module.scss";

const Header = (props) => {
  const location = useLocation();
  const [openSidebar, set_openSidebar] = useState(false);
  const toggle_sidebar = () => {
    set_openSidebar(!openSidebar);
  };
  const handleClose_sidebar = () => {
    set_openSidebar(false);
  };

  return (
    <header
      style={{
        position: "sticky",
        top: "0",
        width: "100%",
        maxWidth: "800px",
        zIndex: "20",
      }}
      className="main_header mx-auto m-0 p-3 px-2  d-flex flex-row justify-content-between align-items-center"
    >
      <IconButton onClick={toggle_sidebar} aria-label="menu">
        <MenuOutlined
          htmlColor={colors["main-color-2-contrast"]}
          fontSize="medium"
        />
      </IconButton>
      <span className="title fs-5 fw-bold text-white">
        {location.pathname === "/" && "مبلیکس"}
        {location.pathname === "/bargaining" && "چانه زنی"}
        {location.pathname === "/products" && "محصولات"}
        {location.pathname === "/orders" && "سفارشات"}
        {location.pathname === "/pallete" && "کالیته ها"}
        {location.pathname === "/support" && "پشتیبانی"}
        {location.pathname === "/messages" && "پبام ها"}
        {location.pathname === "/profile" && "پروفایل "}
      </span>
      <IconButton aria-label="alarm">
        {/* <NotificationsNoneIcon
          htmlColor={colors["main-color-2-contrast"]}
          fontSize="medium"
        /> */}
      </IconButton>

      <Aside open={openSidebar} onClose={handleClose_sidebar} />
    </header>
  );
};

export default Header;
